module.exports = __webpack_public_path__ + "static/media/EndocardialSegmentation_1-1267w.3ea22806.webp";